/* Keep Shopify's variant, product-form and app integrations behind the Paper UI. */
if (!customElements.get('brewno-grind')) {
  customElements.define('brewno-grind', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.boundForms = new WeakSet();
      this.observer = new MutationObserver(() => this.connectSource());
      this.observer.observe(this.closest('.brewno-product'), { childList: true, subtree: true });
      this.connectSource();
    }

    connectSource() {
      const form = document.getElementById(this.dataset.formId);
      if (!form) return;
      const group = [...form.querySelectorAll('.gpo-dropdown')].find((dropdown) =>
        [...dropdown.querySelectorAll('input[type="checkbox"]')].some((input) => input.value.toLocaleLowerCase('ro') === 'boabe')
      );
      if (!group) return;
      if (this.group === group && this.sources?.every((input) => input.isConnected)) {
        this.sync();
        return;
      }
      this.group = group;
      this.sources = [...group.querySelectorAll('input[type="checkbox"]')];
      (group.closest('.gpo-element') || group).classList.add('brewno-grind-source');
      this.replaceChildren();
      const fieldset = document.createElement('fieldset');
      const legend = document.createElement('legend');
      legend.textContent = 'Măcinare';
      const options = document.createElement('div');
      options.className = 'brewno-grind__options';
      this.sources.forEach((source) => {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `brewno-grind-${this.dataset.formId}`;
        input.value = source.value;
        const text = source.value.toLocaleLowerCase('ro');
        label.append(input, document.createTextNode(text.charAt(0).toLocaleUpperCase('ro') + text.slice(1)));
        options.append(label);
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.sources.forEach((original) => {
            if (original.checked !== (original.value === input.value)) original.click();
          });
          this.sync();
        }, { signal: this.abort.signal });
      });
      fieldset.append(legend, options);
      this.append(fieldset);
      if (!this.sources.some((source) => source.checked)) this.sources[0].click();
      if (!this.boundForms.has(form)) {
        form.addEventListener('change', (event) => {
          if (this.group?.contains(event.target)) queueMicrotask(() => this.sync());
        }, { signal: this.abort.signal });
        this.boundForms.add(form);
      }
      this.hidden = false;
      this.sync();
    }

    sync() {
      const selected = this.sources?.find((input) => input.checked)?.value;
      this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = input.value === selected; });
    }

    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('brewno-purchase')) {
  customElements.define('brewno-purchase', class extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.dataset.sectionId) return;
        const button = this.querySelector('[data-brewno-price]');
        const updated = event.data.html.querySelector('[data-brewno-price]');
        if (button && updated && !button.disabled) {
          button.dataset.brewnoPrice = updated.dataset.brewnoPrice;
          button.querySelector('span').textContent = `${button.dataset.brewnoLabel} — ${updated.dataset.brewnoPrice}`;
        }
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}

if (!customElements.get('brewno-cart')) {
  customElements.define('brewno-cart', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.pending = new Map();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        const button = event.target.closest('[data-delta]');
        if (!remove && !button) return;
        event.preventDefault();
        const control = remove || button;
        const row = control.closest('[data-cart-row]');
        const input = row.querySelector('[data-cart-quantity]');
        let quantity = 0;
        if (button) {
          quantity = Number(input.value) + Number(button.dataset.delta) * Number(input.step || 1);
          if (quantity < Number(input.dataset.min || 1)) quantity = button.dataset.delta === '-1' ? 0 : Number(input.dataset.min || 1);
        }
        this.focusTarget = { key: row.dataset.key, control: remove ? 'remove' : button.dataset.delta };
        this.queue(row, quantity);
      }, options);
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-cart-quantity]')) return;
        const input = event.target;
        const row = input.closest('[data-cart-row]');
        this.focusTarget = { key: row.dataset.key, control: 'input' };
        if (!Number.isInteger(input.valueAsNumber) || input.valueAsNumber < 0 || !input.checkValidity()) {
          input.value = input.dataset.originalQuantity;
          this.showError('Introdu o cantitate validă.');
          return;
        }
        this.queue(row, input.valueAsNumber);
      }, options);
      this.addEventListener('submit', (event) => {
        if (this.processing) event.preventDefault();
      }, options);
    }

    queue(row, quantity) {
      if (!Number.isInteger(quantity) || quantity < 0) return;
      row.querySelector('[data-cart-quantity]').value = quantity;
      if (quantity === 0) row.inert = true;
      this.pending.set(row.dataset.key, quantity);
      this.showError('');
      this.flush();
    }

    setBusy(busy) {
      this.setAttribute('aria-busy', String(busy));
      const checkout = this.querySelector('[name="checkout"]');
      if (checkout) checkout.disabled = busy;
      const accelerated = this.querySelector('[data-accelerated-checkout]');
      if (accelerated) accelerated.inert = busy;
    }

    async flush() {
      if (this.processing) return;
      this.processing = true;
      this.setBusy(true);
      while (this.pending.size && this.isConnected) {
        const [key, quantity] = this.pending.entries().next().value;
        this.pending.delete(key);
        try {
          const endpoint = window.routes.cart_change_url.replace(/(?:\.js)?$/, '.js');
          const response = await fetch(endpoint, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity, sections: [this.dataset.sectionId, 'cart-icon-bubble'], sections_url: window.routes.cart_url }),
            signal: this.abort.signal,
          });
          const cart = await response.json();
          if (!response.ok || cart.errors) throw new Error(cart.description || (typeof cart.errors === 'string' ? cart.errors : 'Cantitatea nu este disponibilă.'));
          let html = cart.sections?.[this.dataset.sectionId];
          if (!html) html = await this.fetchSection();
          if (!this.isConnected) return;
          this.render(html);
          const icon = document.getElementById('cart-icon-bubble');
          if (icon && cart.sections?.['cart-icon-bubble']) {
            const fragment = new DOMParser().parseFromString(cart.sections['cart-icon-bubble'], 'text/html');
            icon.innerHTML = fragment.querySelector('.shopify-section').innerHTML;
          }
          const actual = cart.items.find((item) => item.key === key)?.quantity || 0;
          this.querySelector('[data-cart-message]').textContent = actual !== quantity
            ? 'Cantitatea a fost ajustată la stocul disponibil.'
            : `Coș actualizat. ${cart.item_count} ${cart.item_count === 1 ? 'produs' : 'produse'}.`;
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'brewno-cart', cartData: cart });
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.pending.clear();
          try { this.render(await this.fetchSection()); } catch { /* Keep the current form available for a manual retry. */ }
          if (!this.isConnected) return;
          this.showError(error.message || 'Coșul nu a putut fi actualizat. Încearcă din nou.');
          break;
        }
      }
      this.processing = false;
      this.setBusy(false);
    }

    async fetchSection() {
      const response = await fetch(`${window.routes.cart_url}?section_id=${encodeURIComponent(this.dataset.sectionId)}`, { signal: this.abort.signal });
      if (!response.ok) throw new Error('Coșul nu a putut fi actualizat. Încearcă din nou.');
      return response.text();
    }

    render(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('brewno-cart');
      if (!parsed) throw new Error('Coșul nu a putut fi afișat. Reîncarcă pagina.');
      const accelerated = this.querySelector('[data-accelerated-checkout]');
      this.className = parsed.className;
      this.innerHTML = parsed.innerHTML;
      const newAccelerated = this.querySelector('[data-accelerated-checkout]');
      if (accelerated && newAccelerated) newAccelerated.replaceWith(accelerated);
      this.pending.forEach((quantity, key) => {
        const row = this.querySelector(`[data-key="${CSS.escape(key)}"]`);
        if (row) { row.querySelector('[data-cart-quantity]').value = quantity; row.inert = quantity === 0; }
      });
      this.setBusy(this.processing);
      const focus = this.focusTarget;
      const row = focus && this.querySelector(`[data-key="${CSS.escape(focus.key)}"]`);
      const target = row && row.querySelector(focus.control === 'input' ? '[data-cart-quantity]' : focus.control === 'remove' ? '[data-cart-remove]' : `[data-delta="${focus.control}"]`);
      if (target) target.focus({ preventScroll: true });
      else if (this.querySelector('[data-empty-heading]')) this.querySelector('[data-empty-heading]').focus({ preventScroll: true });
    }

    showError(message) {
      const error = this.querySelector('[data-cart-error]');
      if (error) error.textContent = message;
    }

    disconnectedCallback() { this.abort?.abort(); }
  });
}
